// c:\xampp\htdocs\miners-market-main\components\ProductForm.js

import { REBUILD_CLASSIFICATIONS } from '../utils/shared.js';
import AccordionSection from './AccordionSection.jsx';
import MediaManager from './forms/MediaManager.jsx';

export default function ProductForm({
    formData,
    categories,
    onFormChange,
    openSection,
    onToggleSection,
}) {
    const isRebuild = formData.form_type === 'rebuild';
    // NEW: Find the selected classification details
    const selectedClassification = isRebuild ? REBUILD_CLASSIFICATIONS.find(c => c.id === formData.rebuild_classification) : null;

    return (
        <div className="space-y-2">
            <AccordionSection title="1. Product Information" id="productInfo" openSection={openSection} onToggle={onToggleSection}>
                {/* NEW: Display classification badge */}
                {selectedClassification && (
                    <div className={`p-4 mb-6 rounded-lg border ${selectedClassification.badgeClasses} flex items-center gap-4`}>
                        <i className={`${selectedClassification.icon} text-2xl`}></i>
                        <div>
                            <h4 className={`font-bold text-lg ${selectedClassification.titleColor}`}>{selectedClassification.title}</h4>
                            <p className={`text-sm ${selectedClassification.descColor}`}>{selectedClassification.desc}</p>
                        </div>
                    </div>
                )}

                <div className="grid md:grid-cols-2 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Item Name*</label>
                        <input type="text" name="name" value={formData.name || ''} onChange={onFormChange} required className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Manufacturer/Brand{isRebuild ? '*' : ''}</label>
                        <input type="text" name="manufacturer" value={formData.manufacturer || ''} onChange={onFormChange} required={isRebuild} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                    </div>
                </div>
                {isRebuild ? (
                    <>
                        <div className="grid md:grid-cols-2 gap-4">
                            <div>
                                <label className="block text-sm font-medium text-gray-700">Model*</label>
                                <input type="text" name="model_number" value={formData.model_number || ''} onChange={onFormChange} required className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700">Serial Number*</label>
                                <input type="text" name="serial_number" value={formData.serial_number || ''} onChange={onFormChange} required className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                            </div>
                        </div>
                        <div className="grid md:grid-cols-2 gap-4">
                            <div>
                                <label className="block text-sm font-medium text-gray-700">Year*</label>
                        <input type="text" name="year" value={formData.year ?? ''} onChange={onFormChange} required className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700">Operating Hours*</label>
                        <input type="text" name="hours" value={formData.hours ?? ''} onChange={onFormChange} required className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                            </div>
                        </div>
                    </>
                ) : (
                    <>
                        <div className="grid md:grid-cols-2 gap-4">
                            <div>
                                <label className="block text-sm font-medium text-gray-700">Model Number</label>
                                <input type="text" name="model_number" value={formData.model_number || ''} onChange={onFormChange} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700">Part Number</label>
                                <input type="text" name="part_number" value={formData.part_number || ''} onChange={onFormChange} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                            </div>
                        </div>
                        <div className="grid md:grid-cols-2 gap-4">
                            <div>
                                <label className="block text-sm font-medium text-gray-700">Serial Number</label>
                                <input type="text" name="serial_number" value={formData.serial_number || ''} onChange={onFormChange} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700">Application</label>
                                <input type="text" name="application" value={formData.application || ''} onChange={onFormChange} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                            </div>
                        </div>
                        <div className="grid md:grid-cols-2 gap-4">
                            <div>
                                <label className="block text-sm font-medium text-gray-700">Condition*</label>
                                <select name="item_condition" value={formData.item_condition || 'Used'} onChange={onFormChange} required className="mt-1 block w-full border-gray-300 rounded-md shadow-sm">
                                    <option>New</option>
                                    <option>Used</option>
                                    <option>Refurbished</option>
                                </select>
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700">Quantity Available*</label>
                                <input type="text" name="quantity" value={formData.quantity ?? ''} onChange={onFormChange} required className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" placeholder="0" />
                            </div>
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Technical Specifications</label>
                            <textarea
                                name="specifications"
                                value={formData.specifications || ''}
                                onChange={onFormChange}
                                rows="3"
                                className="mt-1 block w-full border-gray-300 rounded-md shadow-sm"
                                placeholder="e.g. Voltage, Power, Dimensions, Material, etc."
                            ></textarea>
                        </div>
                    </>
                )}
                <div>
                    <label className="block text-sm font-medium text-gray-700">Description*</label>
                    <textarea
                        name="description"
                        value={formData.description || ''}
                        onChange={onFormChange}
                        required
                        rows="4"
                        className="mt-1 block w-full border-gray-300 rounded-md shadow-sm"
                    ></textarea>
                </div>
            </AccordionSection>

            <AccordionSection title="2. Images & Documents" id="images" openSection={openSection} onToggle={onToggleSection}>
                <MediaManager formData={formData} onFormChange={onFormChange} />
            </AccordionSection>

            {!isRebuild && (
            <AccordionSection title="3. Pricing & Category" id="pricing" openSection={openSection} onToggle={onToggleSection}>
                <div className="grid md:grid-cols-2 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Unit Price (R)*</label>
                        <input type="text" name="price" value={formData.price ?? ''} onChange={onFormChange} required className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" placeholder="0.00" />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Category*</label>
                        <select name="category_id" value={formData.category_id || ''} onChange={onFormChange} required className="mt-1 block w-full border-gray-300 rounded-md shadow-sm">
                            <option value="" disabled>-- Select a Category --</option>
                            {categories && categories
                                .filter(c => !c.parent_id)
                                .map(group => (
                                    <optgroup key={group.id} label={group.name}>
                                        {categories.filter(sub => sub.parent_id === group.id).map(sub => (
                                            <option key={sub.id} value={sub.id}>{sub.name}</option>
                                        ))}
                                    </optgroup>
                                ))}
                        </select>
                    </div>
                </div>
                <div className="mt-4 pt-4 border-t border-gray-200">
                    <div className="relative flex items-start">
                        <div className="flex items-center h-5">
                            <input
                                id="is_price_on_request"
                                name="is_price_on_request"
                                type="checkbox"
                                checked={!!formData.is_price_on_request}
                                onChange={onFormChange}
                                className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded"
                            />
                        </div>
                        <div className="ml-3 text-sm">
                            <label htmlFor="is_price_on_request" className="font-medium text-gray-700">Set Price on Request</label>
                            <p className="text-gray-500">
                                {formData.is_price_on_request 
                                    ? "This price will not be publicly shown. It will only be revealed to verified buyers who go through the Price on Request process."
                                    : "Check this box to hide the price from public view."
                                }
                            </p>
                        </div>
                    </div>
                </div>
            </AccordionSection>
            )}

            <AccordionSection title={isRebuild ? "3. Delivery & Logistics" : "4. Delivery & Logistics"} id="logistics" openSection={openSection} onToggle={onToggleSection}>
                <div className="grid md:grid-cols-2 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Current Location*</label>
                        <select name="location" value={formData.location || ''} onChange={onFormChange} required className="mt-1 block w-full border-gray-300 rounded-md shadow-sm">
                            <option value="" disabled>Select Province</option>
                            <option value="Eastern Cape">Eastern Cape</option>
                            <option value="Free State">Free State</option>
                            <option value="Gauteng">Gauteng</option>
                            <option value="KwaZulu-Natal">KwaZulu-Natal</option>
                            <option value="Limpopo">Limpopo</option>
                            <option value="Mpumalanga">Mpumalanga</option>
                            <option value="North West">North West</option>
                            <option value="Northern Cape">Northern Cape</option>
                            <option value="Western Cape">Western Cape</option>
                        </select>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Shipping Terms</label>
                        <input type="text" name="shipping_terms" value={formData.shipping_terms || ''} onChange={onFormChange} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" placeholder="e.g., EXW / FOB / CIF – Port" />
                    </div>
                </div>
                <div className="grid md:grid-cols-2 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Packaging</label>
                        <input type="text" name="packaging" value={formData.packaging || ''} onChange={onFormChange} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" placeholder="e.g., Crate, Pallet, Box" />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Estimated Delivery Time</label>
                        <input type="text" name="delivery_time" value={formData.delivery_time || ''} onChange={onFormChange} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" placeholder="e.g., 5-7 business days" />
                    </div>
                </div>
            </AccordionSection>

            {!isRebuild && (
            <AccordionSection title="5. Compatibility & Support" id="compatibility" openSection={openSection} onToggle={onToggleSection}>
                <div>
                    <label className="block text-sm font-medium text-gray-700">Compatibility Information</label>
                    <textarea
                        name="compatibility"
                        value={formData.compatibility || ''}
                        onChange={onFormChange}
                        rows="3"
                        className="mt-1 block w-full border-gray-300 rounded-md shadow-sm"
                        placeholder="e.g., Compatible with CAT 320D, John Deere 50G"
                    ></textarea>
                </div>
            </AccordionSection>
            )}

            <AccordionSection title={isRebuild ? "4. Contact Information" : "6. Contact Information"} id="contact" openSection={openSection} onToggle={onToggleSection}>
                <div className="grid md:grid-cols-2 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Sales Contact Name</label>
                        <input type="text" name="sales_contact_name" value={formData.sales_contact_name || ''} onChange={onFormChange} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Sales Contact Phone</label>
                        <input type="tel" name="sales_contact_phone" value={formData.sales_contact_phone || ''} onChange={onFormChange} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                    </div>
                </div>
                <div className="grid md:grid-cols-2 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Sales Contact Email</label>
                        <input type="email" name="sales_contact_email" value={formData.sales_contact_email || ''} onChange={onFormChange} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Company Name & Address</label>
                        <input type="text" name="company_name_address" value={formData.company_name_address || ''} onChange={onFormChange} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                    </div>
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700">Support Contact Details</label>
                    <textarea
                        name="support_contact_details"
                        value={formData.support_contact_details || ''}
                        onChange={onFormChange}
                        rows="3"
                        className="mt-1 block w-full border-gray-300 rounded-md shadow-sm"
                        placeholder="e.g., Technical support line, email, or website"
                    ></textarea>
                </div>
            </AccordionSection>
        </div>
    );
}
